import { fromJS, Map, List } from 'immutable';
import { UsersRecord, DepartmentInfoRecord } from './../Record/Users';

// const DOMAIN_NAME = '';
const NAME_SPACE = 'USERS/';

const initialState = new Map({
  'loading': false,
  'users': new UsersRecord(),
  'department': new List([]),
});

// let umid = 0;

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_DEPARTMENT':
      return state.update('department', () => fromJS(action.payload.data));
    case NAME_SPACE + 'ADD_DEPARTMENT_INFO':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.department.u_id ? true : false), user => {
            return user.update('department_info', department_info => {
              return department_info.push(new DepartmentInfoRecord(action.payload.department));
            });
          });
        });
      });
    case NAME_SPACE + 'DEL_EPARTMENT_INFO':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.department.u_id ? true : false), user => {
            return user.update('department_info', department_info => {
              return department_info.delete(department_info.findIndex(x => x.get('um_id') === action.payload.department.um_id ? true : false));
            });
          });
        });
      });
    case NAME_SPACE + 'RECEIVE_USERS':
      const dataSize = action.payload.data.length;
      return state.update('users', () => fromJS(dataSize === 0 ? initialState.get('users') : action.payload));
    case NAME_SPACE + 'REQUEST_USERS':
      return state.update('users', users => users.merge(action.payload));
    case NAME_SPACE + 'EDIT_USER':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.user.u_id ? true : false), user => {
            return user.merge(action.payload.user);
          });
        });
      });
    case NAME_SPACE + 'ADD_ROLES_INOF':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.roles.get('u_id') ? true : false), user => {
            return user.update('roles_info', roles_info => {
              const r = action.payload.roles;
              return roles_info.push(r);
            });
          });
        });
      });
    case NAME_SPACE + 'EDIT_ROLES_INOF':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.roles.u_id ? true : false), user => {
            return user.update('roles_info', roles_info => {
              return roles_info.update(roles_info.findIndex(r => {
                const um_id = r.get('attr').um_id || r.get('attr').get('um_id');
                return um_id === action.payload.roles.attr.um_id ? true : false
              }), role => {
                const attr = (role.toJS()).attr;
                action.payload.roles.attr = Object.assign(attr, action.payload.roles.attr);
                // console.log('s', action.payload.roles.attr, action.payload.roles.attr)
                // const _ = role.merge(action.payload.roles);
                console.log(role.merge(action.payload.roles).toJS());
                return role.merge(action.payload.roles);
              });
            });
          });
        });
      });
    case NAME_SPACE + 'DEL_ROLES_INFO':
      return state.update('users', users => {
        return users.update('data', data => {
          return data.update(data.findIndex(o => o.get('u_id') === action.payload.roles.u_id ? true : false), user => {
            return user.update('roles_info', roles_info => {
              return roles_info.delete(roles_info.findIndex(x => x.get('attr').get('um_id') === action.payload.roles.um_id ? true : false));
            });
          });
        });
      });
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_DEPARTMENT':
      return item(state, action);
    case NAME_SPACE + 'ADD_DEPARTMENT_INFO':
      return item(state, action);
    case NAME_SPACE + 'DEL_EPARTMENT_INFO':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_USERS':
      return item(state, action);
    case NAME_SPACE + 'REQUEST_USERS':
      return item(state, action);
    case NAME_SPACE + 'EDIT_USER':
      return item(state, action);
    case NAME_SPACE + 'ADD_ROLES_INOF':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ROLES_INOF':
      return item(state, action);
    case NAME_SPACE + 'DEL_ROLES_INFO':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};